<script>
  import Accordion from "../Accordion.svelte"
  export let datos_adicionales
  export let cliente
  import { createEventDispatcher } from "svelte"
  import { BASE_URL } from "../../stores/BASE_URL"
  import { user } from "../../stores/User"
  import getMoneda, { redondear } from "../../services/moneda.js"

  const dispatch = createEventDispatcher()

  let telefono_tipo = ""
  let correo_tipo = ""
  let direccion_tipo = ""
  let laboral_tipo = ""

  let isSettingTelefono = false
  let isSettingCorreo = false
  let isSettingDireccion = false
  let isSettingLaboral = false

  const encabezados_telefonos = [
    "Fecha actualización",
    "Teléfono",
    "Fuente",
    "Plan",
    "",
  ]
  const encabezados_correos = ["Fecha actualización", "Correo", "Fuente", ""]
  const encabezados_direcciones = [
    "Fecha actualización",
    "Departamento",
    "Provincia",
    "Distrito",
    "Dirección",
    "Fuente",
    "",
  ]
  const encabezados_laborales = [
    "RUC",
    "Razón social",
    "Devengue",
    "Ingreso",
    "",
  ]

  const updateTelefonoVerificado = async (telefono) => {
    if (telefono_tipo === "") {
      return
    }

    isSettingTelefono = true

    const response = await fetch(`${BASE_URL}crm.php`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        ops: "updateTelefonoVerificado",
        id: cliente.id,
        telefono,
        tipo: telefono_tipo,
        session_key: $user.session_key,
      }),
    })
    const data = await response.json()
    if (data.status === "ok") {
      telefono_tipo = ""
      dispatch("update")
    } else {
      console.error("Error al actualizar teléfono verificado:", data.message)
    }
    isSettingTelefono = false
  }

  const updateCorreoVerificado = async (correo) => {
    if (correo_tipo === "") {
      return
    }

    isSettingCorreo = true

    const response = await fetch(`${BASE_URL}crm.php`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        ops: "updateCorreoVerificado",
        id: cliente.id,
        correo,
        tipo: correo_tipo,
        session_key: $user.session_key,
      }),
    })
    const data = await response.json()
    if (data.status === "ok") {
      correo_tipo = ""
      dispatch("update")
    } else {
      console.error("Error al actualizar correo verificado:", data.message)
    }
    isSettingCorreo = false
  }

  const updateDireccionVerificada = async (direccion, ubigeo) => {
    if (direccion_tipo === "") {
      return
    }

    isSettingDireccion = true

    const response = await fetch(`${BASE_URL}crm.php`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        ops: "updateDireccionVerificada",
        id: cliente.id,
        direccion,
        ubigeo,
        tipo: direccion_tipo,
        session_key: $user.session_key,
      }),
    })
    const data = await response.json()
    if (data.status === "ok") {
      direccion_tipo = ""
      dispatch("update")
    } else {
      console.error("Error al actualizar dirección verificada:", data.message)
    }
    isSettingDireccion = false
  }

  const updateDatosLaborales = async (
    laboral_ruc,
    laboral_razon_social,
    laboral_devengue,
    laboral_p1,
  ) => {
    if (laboral_tipo === "") {
      return
    }

    isSettingLaboral = true

    const response = await fetch(`${BASE_URL}crm.php`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        ops: "updateDatosLaborales",
        id: cliente.id,
        laboral_ruc,
        laboral_razon_social,
        laboral_devengue,
        laboral_p1,
        session_key: $user.session_key,
        info_adicional: "1",
      }),
    })
    const data = await response.json()
    if (data.status === "ok") {
      laboral_tipo = ""
      dispatch("update")
    } else {
      console.error(
        "Error al actualizar datos laborales verificados:",
        data.message,
      )
    }
    isSettingLaboral = false
  }
</script>

<div class="mb-5">
  <Accordion title="Teléfonos" idx="accordion-adicionales-t">
    <div class="table-responsive">
      <table class="table table-striped table-sm">
        <thead>
          <tr>
            {#each encabezados_telefonos as encabezado}
              <th class="fg-secondary fw-normal">{encabezado}</th>
            {/each}
          </tr>
        </thead>
        <tbody>
          {#each datos_adicionales.telefonos as telefono}
            <tr>
              <td>{telefono.fecha_actualizacion}</td>
              <td>{telefono.telefono}</td>
              <td>{telefono.fuente}</td>
              <td>{telefono.plan}</td>
              <td class="text-end">
                {#if telefono.telefono == cliente.telef_principal}
                  Principal <i class="bi bi-check-circle ms-1 fg-success"></i>
                {:else if telefono.telefono == cliente.telef_secundario}
                  Secundario <i class="bi bi-check-circle ms-1 fg-secondary"
                  ></i>
                {:else}
                  <div class="d-inline-block">
                    <select
                      class="form-control form-control-sm py-0"
                      bind:value={telefono_tipo}
                      on:change={() =>
                        updateTelefonoVerificado(telefono.telefono)}
                      disabled={isSettingTelefono}
                    >
                      <option value="">Seleccionar</option>
                      <option value="telef_principal">Principal</option>
                      <option
                        value="telef_secundario"
                        disabled={cliente.telef_principal == ""}
                        >Secundario</option
                      >
                    </select>
                  </div>
                {/if}
              </td>
            </tr>
          {:else}
            <tr>
              <td colspan="5" class="text-center fg-secondary"
                >· · · No tiene información · · ·</td
              >
            </tr>
          {/each}
        </tbody>
      </table>
    </div>
  </Accordion>
  <Accordion title="Correos" idx="accordion-adicionales-c">
    <div class="table-responsive">
      <table class="table table-striped table-sm">
        <thead>
          <tr>
            {#each encabezados_correos as encabezado}
              <th class="fg-secondary fw-normal">{encabezado}</th>
            {/each}
          </tr>
        </thead>
        <tbody>
          {#each datos_adicionales.correos as correo}
            <tr>
              <td>{correo.fecha_actualizacion}</td>
              <td>{correo.correo.toLowerCase()}</td>
              <td>{correo.fuente}</td>
              <td class="text-end">
                {#if correo.correo == cliente.correo_principal}
                  Principal <i class="bi bi-check-circle ms-1 fg-success"></i>
                {:else if correo.correo == cliente.correo_secundario}
                  Secundario <i class="bi bi-check-circle ms-1 fg-secondary"
                  ></i>
                {:else}
                  <div class="d-inline-block">
                    <select
                      class="form-control form-control-sm py-0"
                      bind:value={correo_tipo}
                      on:change={() => updateCorreoVerificado(correo.correo)}
                      disabled={isSettingCorreo}
                    >
                      <option value="">Seleccionar</option>
                      <option value="correo_principal">Principal</option>
                      <option
                        value="correo_secundario"
                        disabled={cliente.correo_principal == ""}
                        >Secundario</option
                      >
                    </select>
                  </div>
                {/if}
              </td>
            </tr>
          {:else}
            <tr>
              <td colspan="4" class="text-center fg-secondary"
                >· · · No tiene información · · ·</td
              >
            </tr>
          {/each}
        </tbody>
      </table>
    </div>
  </Accordion>
  <Accordion title="Direcciones" idx="accordion-adicionales-d">
    <div class="table-responsive">
      <table class="table table-striped table-sm">
        <thead>
          <tr>
            {#each encabezados_direcciones as encabezado}
              <th class="fg-secondary fw-normal">{encabezado}</th>
            {/each}
          </tr>
        </thead>
        <tbody>
          {#each datos_adicionales.direcciones as direccion}
            <tr>
              <td>{direccion.fecha_actualizacion}</td>
              <td>{direccion.departamento}</td>
              <td>{direccion.provincia}</td>
              <td>{direccion.distrito}</td>
              <td>{direccion.direccion}</td>
              <td>{direccion.fuente}</td>
              <td class="text-end">
                {#if direccion.direccion == cliente.direccion}
                  Principal <i class="bi bi-check-circle ms-1 fg-success"></i>
                {:else}
                  <div class="d-inline-block">
                    <select
                      class="form-control form-control-sm py-0"
                      bind:value={direccion_tipo}
                      on:change={() =>
                        updateDireccionVerificada(
                          direccion.direccion,
                          direccion.ubigeo,
                        )}
                      disabled={isSettingDireccion}
                    >
                      <option value="">Seleccionar</option>
                      <option value="direccion">Principal</option>
                    </select>
                  </div>
                {/if}
              </td>
            </tr>
          {:else}
            <tr>
              <td colspan="7" class="text-center fg-secondary"
                >· · · No tiene información · · ·</td
              >
            </tr>
          {/each}
        </tbody>
      </table>
    </div>
  </Accordion>
  <Accordion title="Datos laborales" idx="accordion-adicionales-l">
    <div class="table-responsive">
      <table class="table table-striped table-sm">
        <thead>
          <tr>
            {#each encabezados_laborales as encabezado}
              <th class="fg-secondary fw-normal">{encabezado}</th>
            {/each}
          </tr>
        </thead>
        <tbody>
          {#each datos_adicionales.empleos as empleo}
            <tr>
              <td>{empleo.ruc}</td>
              <td>{empleo.razon_social}</td>
              <td>{empleo.devengue}</td>
              <td> {getMoneda(redondear(empleo.p1))}</td>
              <td class="text-end">
                {#if empleo.ruc == cliente.laboral_ruc}
                  Principal <i class="bi bi-check-circle ms-1 fg-success"></i>
                {:else}
                  <div class="d-inline-block">
                    <select
                      class="form-control form-control-sm py-0"
                      bind:value={laboral_tipo}
                      on:change={() =>
                        updateDatosLaborales(
                          empleo.ruc,
                          empleo.razon_social,
                          empleo.devengue,
                          empleo.p1,
                        )}
                    >
                      <option value="">Seleccionar</option>
                      <option value="laboral_ruc">Principal</option>
                    </select>
                  </div>
                {/if}
              </td>
            </tr>
          {:else}
            <tr>
              <td colspan="5" class="text-center fg-secondary"
                >· · · No tiene información · · ·</td
              >
            </tr>
          {/each}
        </tbody>
      </table>
    </div>
  </Accordion>
</div>
